import { Link } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1 className="notfound-title">404</h1>
        <h2 className="notfound-subtitle">Page introuvable</h2>
        <p className="notfound-text">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>

        <div className="notfound-links">
          <Link to="/" className="notfound-button primary">
            Retour à l'accueil
          </Link>
          <Link to="/contact" className="notfound-button secondary">
            Nous contacter
          </Link>
        </div>

        <div className="notfound-suggestions">
          <h3>Pages populaires :</h3>
          <ul>
            <li>
              <Link to="/appartement-407-4-etoiles-chatel-guyon">
                Appartement 407 (4 étoiles)
              </Link>
            </li>
            <li>
              <Link to="/studio-516-2-etoiles-chatel-guyon">
                Studio 516 (2 étoiles)
              </Link>
            </li>
            <li>
              <Link to="/contact">Contact & Réservation</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
